module.exports = __webpack_public_path__ + "static/img/copacol-coopera-sempre.ffb2b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/copacol-coopera-sempre.png
// module id = Vmel
// module chunks = 4